<template>
    <div>
        <label class="opui-form-check-label"><input type="checkbox" class="opui-form-check-input" value="1" v-model="row.value"> {{ $e('January') }}</label>
        <label class="opui-form-check-label"><input type="checkbox" class="opui-form-check-input" value="2" v-model="row.value"> {{ $e('February') }}</label>
        <label class="opui-form-check-label"><input type="checkbox" class="opui-form-check-input" value="3" v-model="row.value"> {{ $e('March') }}</label>
        <label class="opui-form-check-label"><input type="checkbox" class="opui-form-check-input" value="4" v-model="row.value"> {{ $e('April') }}</label>
        <label class="opui-form-check-label"><input type="checkbox" class="opui-form-check-input" value="5" v-model="row.value"> {{ $e('May') }}</label>
        <label class="opui-form-check-label"><input type="checkbox" class="opui-form-check-input" value="6" v-model="row.value"> {{ $e('June') }}</label>
        <label class="opui-form-check-label"><input type="checkbox" class="opui-form-check-input" value="7" v-model="row.value"> {{ $e('July') }}</label>
        <label class="opui-form-check-label"><input type="checkbox" class="opui-form-check-input" value="8" v-model="row.value"> {{ $e('August') }}</label>
        <label class="opui-form-check-label"><input type="checkbox" class="opui-form-check-input" value="9" v-model="row.value"> {{ $e('September') }}</label>
        <label class="opui-form-check-label"><input type="checkbox" class="opui-form-check-input" value="10" v-model="row.value"> {{ $e('October') }}</label>
        <label class="opui-form-check-label"><input type="checkbox" class="opui-form-check-input" value="11" v-model="row.value"> {{ $e('November') }}</label>
        <label class="opui-form-check-label"><input type="checkbox" class="opui-form-check-input" value="12" v-model="row.value"> {{ $e('December') }}</label>
    </div>
</template>

<script>
export default {
    props: {
        row: { type: Object, required: true }
    },
    mounted() {
        if (! this.row.value) {
            this.row.value = []
        }
    }
}
</script>

<style scoped>
.opui-form-check-label {
    margin-right: 15px;
}

.opui-form-check-input {
    margin-left: 0;
    margin-top: -3px;
    position: relative;
}
</style>
